// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  min-height: 100%;
  margin: 0;
}

body {
  background: #f2f3f3;
}

.app-root {
  min-height: 100vh;
}

.signin-shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px;
}

.signin-shell > * {
  width: min(720px, 100%);
}

.google-signin-button {
  min-height: 44px;
}

.floating-flashbar {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: min(960px, calc(100vw - 24px));
  z-index: 2000;
}

.chart-frame,
.gauge-frame {
  height: 260px;
  min-width: 0;
}

.gauge-frame {
  position: relative;
}

.gauge-value {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 2rem;
  font-weight: 700;
  pointer-events: none;
}

.device-id-cell {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.2;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;EAGE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":["html,\nbody,\n#root {\n  min-height: 100%;\n  margin: 0;\n}\n\nbody {\n  background: #f2f3f3;\n}\n\n.app-root {\n  min-height: 100vh;\n}\n\n.signin-shell {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  padding: 32px;\n}\n\n.signin-shell > * {\n  width: min(720px, 100%);\n}\n\n.google-signin-button {\n  min-height: 44px;\n}\n\n.floating-flashbar {\n  position: fixed;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: min(960px, calc(100vw - 24px));\n  z-index: 2000;\n}\n\n.chart-frame,\n.gauge-frame {\n  height: 260px;\n  min-width: 0;\n}\n\n.gauge-frame {\n  position: relative;\n}\n\n.gauge-value {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  font-size: 2rem;\n  font-weight: 700;\n  pointer-events: none;\n}\n\n.device-id-cell {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  line-height: 1.2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
